export function LegalHowItWorksSlide({ isActive: _ }: { isActive: boolean }) {
  const steps = [
    { number: "01", title: "Assign", description: "Tell the agent what you need, in the workspace you already use. The agent structures the task and decides which skills to apply. No new systems. No new logins.", quote: "Prepare the evidence list for the Smith matter." },
    { number: "02", title: "Gather", description: "The agent collects client details and supporting documents. Evidence is structured into clear sets. Missing information is flagged early. No back-and-forth later." },
    { number: "03", title: "Prepare", description: "Application forms prepared using verified case data. Supporting materials assembled into a submission pack using your firm\u2019s templates. Manual formatting and repetitive data entry are handled automatically." },
    { number: "04", title: "Review", description: "The agent presents a structured case file for professional review. The lawyer approves, adjusts, or returns. Every action from intake to submission is logged in a full audit trail. AI prepares. Professionals decide." },
  ];

  return (
    <div className="flex flex-col h-full">
      <h2 className="text-[32px] font-light tracking-tight mb-1 font-[family-name:var(--font-heading)]">
        Assign, gather, prepare, review.
      </h2>
      <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light">
        You stay where you work. The agent comes to you. Assign tasks in Slack, Teams, WhatsApp, or email.
      </p>

      <div className="flex gap-5 mt-8 flex-1 min-h-0">
        {steps.map((step, i) => (
          <div key={step.number} className="flex-1 flex flex-col">
            <span className="text-[10px] font-[family-name:var(--font-mono)] tracking-[0.15em] text-[var(--color-accent)]">
              {step.number}
            </span>
            <div className="flex items-center mt-2 mb-3">
              <div className="w-[6px] h-[6px] rounded-full shrink-0 bg-[var(--color-accent)]" />
              {i < steps.length - 1 && <div className="h-px flex-1 bg-[var(--color-border)]" />}
            </div>
            <h3 className="text-[16px] font-medium mb-2">{step.title}</h3>
            <p className="text-[12px] text-[var(--color-fg-secondary)] leading-relaxed">{step.description}</p>
            {"quote" in step && step.quote && (
              <p className="text-[10px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] italic mt-2">&ldquo;{step.quote}&rdquo;</p>
            )}
          </div>
        ))}
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          Every step is logged. Every output is reviewed by a professional. The agent handles preparation. Your team handles judgement.
        </p>
      </div>
    </div>
  );
}
